import { render } from "./FuturesBalanceActionNumberWidgetLayout.vue?vue&type=template&id=0478941c"
import script from "./FuturesBalanceActionNumberWidgetLayout.vue?vue&type=script&lang=js"
export * from "./FuturesBalanceActionNumberWidgetLayout.vue?vue&type=script&lang=js"
script.render = render

export default script